import { ClientUser, UserDatabase } from '~/types/user';
import useData from '../data/useData';
import useSyncData from '../data/useSyncData';

export const useUser = (userID: string) => {
    const client = useData<ClientUser>(() => {
        if (!userID || userID === 'unknown') return Promise.reject('Invalid user id');
        return UserDatabase.getClientUser(userID);
    }, [userID]);
    return client;
};

export const useSyncUser = (userID: string) => {
    const subscribe = UserDatabase.subscribe(userID);
    const getSnapshot = () => {
        if (!userID || userID === 'unknown') return Promise.reject('Invalid user id');
        return UserDatabase.getClientUser(userID);
    };

    const client = useSyncData<ClientUser>(subscribe, getSnapshot, [userID]);
    return client;
};
